// @flow
import * as React from 'react'

type useSwipeProps = {
  onSwipeLeft: () => void,
  onSwipeRight: () => void,
}

const useSwipe = ({ onSwipeLeft, onSwipeRight }: useSwipeProps) => {
  const [touchStart, setTouchStart] = React.useState(0)
  const [touchEnd, setTouchEnd] = React.useState(0)

  const handleTouchStart = (e: any) => {
    setTouchStart(e.targetTouches[0].clientX)
  }

  const handleTouchMove = (e: any) => {
    setTouchEnd(e.targetTouches[0].clientX)
  }

  const handleTouchEnd = () => {
    if ((touchStart - touchEnd) > 150) onSwipeLeft()
    if ((touchStart - touchEnd) < -150) onSwipeRight()
  }

  return {
    handleTouchStart,
    handleTouchMove,
    handleTouchEnd,
  }
}

export default useSwipe
